import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { merge } from 'lodash';
import { Subscription } from 'rxjs';
import { Note, Vendor } from 'src/app/classes/models';
import { GenericObject } from 'src/app/interfaces/generic-object';
import { GridActionColumnActions } from 'src/app/interfaces/grid-action-column-actions';
import { GridActionColumnMap } from 'src/app/interfaces/grid-action-column-map';
import { NoteDisplayModalComponent } from 'src/app/modals/note-display-modal/note-display-modal.component';
import { NoteEmailDisplayModalComponent } from 'src/app/modals/note-email-display-modal/note-email-display-modal.component';
import { SharedDataService } from 'src/app/services/shared-data.service';
import { ToastService } from 'src/app/services/toast.service';
import { UtilityService } from 'src/app/services/utility.service';
import { VendorService } from 'src/app/services/vendor.service';

@Component({
  selector: 'app-admin-vendor-notes',
  templateUrl: './admin-vendor-notes.component.html',
  styleUrl: './admin-vendor-notes.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AdminVendorNotesComponent {
  constructor(
    private ToastService: ToastService,
    private VendorService: VendorService,
    private SharedDataService: SharedDataService,
    private UtilityService: UtilityService,
    private ModalService: NgbModal,
    private ChangeDetectorRef: ChangeDetectorRef
  ) {
    this.SharedDataServiceSubscription =
      this.SharedDataService.listenForEvent<number>().subscribe({
        next: ({ eventName, data }) => {
          if (eventName === 'SetVendorId' && typeof data === 'number') {
            this.VendorId = data;

            this.suppliedGridQuery = {
              attributes: ['id', 'EmailId'],
              VendorId: data
            };

            this.VendorService.getVendorV2(
              this.VendorId,
              this.UtilityService.stringifyObjectsInQueryObject({
                attributes: ['id', 'legalName']
              })
            ).subscribe({
              next: (Vendor) => {
                const { legalName } = Vendor;

                Object.assign(this, { Vendor });

                if (!legalName) {
                  throw this.ToastService.addErrorToast(
                    'Error',
                    'Vendor is missing legal name.',
                    { returnError: true }
                  );
                }

                this.SharedDataService.sendEvent(
                  'SetTitle',
                  `Notes - ${legalName}`
                );

                this.ChangeDetectorRef.markForCheck();
              }
            });
          }
        }
      });

    this.SharedDataService.sendEvent('GetVendorId');
  }

  VendorId?: number;

  SharedDataServiceSubscription: Subscription;
  suppliedGridQuery?: GenericObject;
  Vendor!: Vendor;

  ColumnIdToColumnActions: GridActionColumnMap = {
    ['$actionColumn']: ['view']
  };

  action({
    action,
    rowData
  }: {
    action: GridActionColumnActions;
    rowData: Note;
  }) {
    if (action === 'view') {
      const { id: NoteId, EmailId } = rowData;

      // No modal, send the Vendor to the bid.
      if (EmailId) {
        // Open note modal to display email.
        const { componentInstance } = this.ModalService.open(
          NoteEmailDisplayModalComponent,
          { backdrop: 'static', size: 'lg' }
        );
        Object.assign(componentInstance, { NoteId });
      } else {
        // Open note modal.
        const { componentInstance } = this.ModalService.open(
          NoteDisplayModalComponent,
          { backdrop: 'static', size: 'lg' }
        );
        Object.assign(componentInstance, { NoteId });
      }
    }
  }

  ngOnDestroy(): void {
    if (this.SharedDataServiceSubscription) {
      this.SharedDataServiceSubscription.unsubscribe();
    }
  }
}
